"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/* ++++++++++ --------------- COLOR PICKER : DEFINITION --------------- ++++++++++ */

var _default2 = {
  name: 'ColorPicker',
  props: {
    label: {
      type: 'string',
      default: 'Color Picker'
    },
    color: {
      type: 'string',
      default: '#FFFFFF'
    },
    savedColor: {
      type: 'string',
      default: '#FFFFFF'
    },
    valid: {
      type: 'boolean',
      default: true,
      options: [false, true]
    },
    processColorUpdate: {
      type: 'function',
      default: function _default(color, e) {
        return console.log(color, e);
      }
    },
    validateColor: {
      type: 'function',
      default: function _default(isValid, e) {
        return console.log(isValid, e);
      }
    },
    handleReset: {
      type: 'function',
      default: function _default(e) {
        return console.log(e);
      }
    }
  }
};
exports.default = _default2;